import { createRouter, createWebHistory } from 'vue-router';

const routes = [
	{
		path: '/auth',
		name: 'SSOAuth',
		component: () => import('./components/auth/SSOHandler.vue'),
		meta: {
			title: 'SSO Authentication',
		},
	},
	{
		path: '/',
		name: 'Home',
		component: () => import('./App.vue'),
		meta: {
			title: 'Application',
		},
	},
];

export const router = createRouter({
	history: createWebHistory(),
	routes,
});
